export enum AuthTypesEnum {
    LOGIN = 'LOGIN',
    REGISTER = 'REGISTER',
}
